import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { frontImage } from "../lib/api";

// The one place that shows a duck's FRONT image. Resolves render→photo, falls back render→photo→neutral placeholder
// on a load error, and never renders a broken <img> (an empty src shows the placeholder instead). Pass `src` to
// override the resolved front (e.g. the "original photo" toggle in Step 3).
export const FrontImage = ({ creation, src: override, fallback, alt = "", className = "", testId, onClick }) => {
  const primary = override != null ? override : frontImage(creation);
  const [src, setSrc] = useState(primary);

  useEffect(() => {
    setSrc(primary);
  }, [primary]);

  if (!src) {
    return (
      <div
        data-testid={testId ? `${testId}-placeholder` : "front-image-placeholder"}
        role="img"
        aria-label={alt}
        className={`grid place-items-center bg-muted text-muted-foreground ${className}`}
      >
        <ImageOff className="h-8 w-8 opacity-40" />
      </div>
    );
  }

  const onError = () => {
    const fb = fallback !== undefined ? fallback : creation?.photo;
    setSrc(fb && fb !== src ? fb : null);
  };

  return <img src={src} alt={alt} data-testid={testId} onClick={onClick} onError={onError} className={className} />;
};
